import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/ucwaStore';

export const setUnreadCount = mutatorAction('UCWA_SetUnreadCount', (count: number) => {
    const store = getStore();
    store.unreadCount = count;
});
